import { UIIcon } from '../config/icons';
import { ABFilter, ABFilterBar } from '../lib/ab/filter-bar';
import { ABProducerSelect } from '../lib/ab/select-admin';
import { ABObjectCount } from '../lib/ab/widgets-admin';
import { c_producers } from '../lib/mdl/c-producer';
import { VVideo, VSubtitle, v_videos, vVideoUploadFile } from '../lib/mdl/v-video';
import { UIDataAdapter } from '../lib/ui/component/adapter';
import { UIButton, makeActionButton } from '../lib/ui/component/button';
import { UIDialog } from '../lib/ui/component/dialog';
import { UIFileInput } from '../lib/ui/component/file-input';
import { UITextInput, UINumberInput, UISearchInput } from '../lib/ui/component/input';
import { UILabeled } from '../lib/ui/component/labeled';
import { UIList } from '../lib/ui/component/list';
import { UIProgressWheel } from '../lib/ui/component/progress';
import { UITableDefinition, UITable } from '../lib/ui/component/table';
import { uiToast } from '../lib/ui/component/toast';
import { addTooltip } from '../lib/ui/component/tooltip';
import { UIVideoDialog } from '../lib/ui/component/video';
import { $el } from '../lib/ui/elements';
import { $fmt } from '../lib/ui/fmt';
import { UIScreen } from '../lib/ui/screen';
import { UIRelPos } from '../lib/ui/types';
import { UIViewSpec } from '../lib/ui/view';
import { YArrayDataSource } from '../lib/y/data-source';
import { xavis_experiments } from '../lib/y/debug';
import { $form } from '../lib/y/form';
import { $location } from '../lib/y/location';
import { $time } from '../lib/y/time';

class UploadVideoDialog extends UIDialog {
    constructor() {
        super({ close: true, classes: 'm-500' });

        const progress = new UIProgressWheel('tl-video');
        progress.ui_hide();

        const name = new UITextInput({ placeholder: 'Name', required: true });
        const file = new UIFileInput({ placeholder: 'Drag file or click to select', required: true, accept: ['video/*'] });
        const buttons = $el.DIV('l-button-row', new UIButton({
            title: "Upload", classes: 'm-round m-compact', on_click: () => {
                if(!$form.validate([name, file])) return;
                progress.ui_show();
                name.ui_hide();
                file.ui_hide();
                buttons.ui_hide();
                return vVideoUploadFile(name.value, file.value[0], p => { progress.progress = p }).then(() => {
                    this.dismiss(true);
                }, message => {
                    uiToast(message);
                    progress.ui_hide();
                    name.ui_show();
                    file.ui_show();
                    buttons.ui_show();
                });
            }
        }));


        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', 'Create VOD'),
            name,
            file,
            buttons,
            progress
        ]));
    }
}

// class EncodeVODDialog extends UIDialog
// {
//     constructor(upload: TLUploadsItem)
//     {
//         super({ close: true, classes: 'm-500' });

//         const name = new UITextInput({ placeholder: 'Name', required: true });
//         const producer = new ABProducerSelect({ placeholder: 'Producer' });

//         name.value = upload.name;

//         this.content.ui_add($el.DIV('w-block l-form m-center',[
//             $el.H2('title', 'Encode VOD'),
//             name,
//             producer,
//             $el.DIV('l-button-row', new UIButton({ title: "Encode", classes: 'm-round m-compact', on_click: () => {
//                 if(!$form.validate([name, producer])) return;
//                 return $tl.createVOD(name.value, producer.value as YId, upload.url).then(() => {
//                     this.dismiss(true);
//                 }, message => {
//                     toast(message);
//                 });
//             }}))
//         ]));
//     }
// }

// class StreamInfoDialog extends UIDialog
// {
//     constructor(stream: TLStream)
//     {
//         super({ close: true, classes: 'm-500' });

//         const url = 'rtmp://' + stream.push_ip + ':' + stream.push_port + '/' + stream.id

//         this.content.ui_add($el.DIV('w-block l-form m-center',[
//             $el.H2('title', 'Stream info'),
//             $el.P('info', 'URL: ' + url),
//             $el.P('info', 'Stream key: ' + stream.token),
//             $el.P('info', 'Full URL: ' + url + '/' + stream.token)
//         ]));
//     }
// }

// class AddSubtitleDialog extends UIDialog
// {
//     constructor(vod: TLVOD)
//     {
//         super({ close: true, classes: 'm-500' });

//         const language_values: UIValue<string>[] = [{key:'en', name: 'English'}, { key: 'sv', name: 'Swedish' }];
//         const lang = new UISelect(language_values, { placeholder: 'Language code', required: true });
//         const file = new UIFileInput({ placeholder: 'Drag file or click to select', required: true, accept: ['text/srt'] });

//         this.content.ui_add($el.DIV('w-block l-form m-center',[
//             $el.H2('title', 'Add subtitle'),
//             lang,
//             file,
//             $el.DIV('l-button-row', new UIButton({ title: "Apply", classes: 'm-round m-compact', on_click: () => {
//                 if(!$form.validate([lang, file])) return;
//                 return $tl.addVODSubtitles(vod.id, lang.value!, file.value[0]).then(vod => {
//                     this.dismiss(true);
//                 }, message => {
//                     toast(message);
//                 });
//             }}))
//         ]));
//     }
// }

// interface WatchVODsResponse {
//     token: string;
// }

class VideoScreen extends UIScreen {
    constructor(private _vod: VVideo) {
        super();
        this.title = _vod.name;
    }

    protected override fillContent(content: UIViewSpec): void {
        const vod = this._vod;

        content.classList.add('tl-admin-page');

        const name = new UITextInput({ required: true });
        const producer = new ABProducerSelect({ no_producer: true });
        const trim_start = new UINumberInput();
        const trim_end = new UINumberInput();
        const start_offset = new UINumberInput();

        const form = $form({ name: name, trim_start, trim_end, start_offset, producer: producer });
        form.value = vod;

        const formats_table = $el.TABLE(['Resolution', 'Bandwidth', 'Frame rate'], vod.renditions.map(s => [s.width + 'x' + s.height, s.bandwidth + '', s.frame_rate + '']), 'tl-frame-table');

        const subs_adapter = new UIDataAdapter<VSubtitle>(s => {
            const remove = new UIButton({
                icon: UIIcon.TRASH_CAN, on_click: () => {
                    // $tl.removeVODSubtitles(vod.id, s.id).then(vod => {
                    //     subs_adapter.data = vod.subtitles;
                    // });
                }
            });
            return $el.DIV('l-input-row', [$el.I(s.language), remove]);
        }, vod.subtitles);

        const section = $el.FORM('ui-section w-form l-form', [
            new UILabeled(name, { above: 'Name' }),
            new UILabeled(producer, { above: 'Producer' }),
            new UILabeled(trim_start, { above: 'Trim at start', below: 'Number of segments to remove at start of movie (a segment is usually 6 seconds)' }),
            new UILabeled(trim_end, { above: 'Trim at end', below: 'Number of segments to remove at end of movie (a segment is usually 6 seconds)' }),
            xavis_experiments && new UILabeled(start_offset, { above: 'Start playback at (seconds)' }),
            xavis_experiments && new UILabeled(formats_table, { above: 'Formats' }),
            new UILabeled(new UIList(subs_adapter, { classes: 'l-form' }), { above: 'Subtitles' })
        ]);

        const button = new UIButton({
            icon: UIIcon.THUMBS_UP, kind: 'k-square', classes: 'm-round ui-action-button', on_click: () => {
                if(!form.validate()) return;

                // $v.videos.update(vod.id, form.value).then(() => {
                //     $location.pop();
                // }, m => {
                //     toast('Error: ' + m);
                // });
            }
        });

        addTooltip('Update', button, { offset: 8, hover: button, position: UIRelPos.Above });

        content.ui_add([section, button]);
    }
}

function filterVideos(vods: VVideo[], filters: ABFilter[], search: UISearchInput) {
    for(const f of filters) {
        if(f.key == 'producer')
            vods = vods.filter(v => v.producer_id && f.value.includes(v.producer_id));
    }

    vods = search.filterArray(vods, (v, w) => {
        if(v.name.toLowerCase().includes(w)) return true;
        if(v.producer_id && c_producers.maybe(v.producer_id)!.name.toLowerCase().includes(w)) return true;
        return false;
    });

    return vods;
}

export class AdminVideosScreen extends UIScreen {
    protected override async fillContent(content: UIViewSpec) {
        let all_videos = await v_videos.getAll();

        const doSearch = () => {
            let videos = filterVideos(all_videos, filters.filters, filter_bar.search_input!);

            count.number = videos.length;
            source.data = videos;
        }

        const count = new ABObjectCount('VODs');
        const filter_bar = new ABFilterBar({
            on_search: doSearch,
            on_filter: doSearch,
            right_content: [count],
            no_header: true
        });

        const filters = filter_bar.filters;
        filters.addFilterButton();
        filters.addProducer();

        const def = new UITableDefinition<VVideo>();
        def.addValue(v => v.name, { title: 'Name', width: 160 });
        def.addValue(v => v.producer_id ? c_producers.maybe(v.producer_id)!.name : '', { title: 'Producer', width: 120 });
        def.addValue(v => $time(v.created_at), $fmt.DATE('d MMM yyyy HH:mm'), { title: 'Uploaded at', width: -180 });
        def.addValue(v => v.status, { title: 'Status', width: -200 });
        def.addValue(v => v.duration ? v.duration / 1000 : undefined, $fmt.DURATION, { title: 'Duration', width: -120 });
        def.addValue(v => v.subtitles ? v.subtitles.map(s => s.language).join(', ') : '', { title: 'Subtitles', width: -90 });
        def.addValue(v => v.event_id != null, $fmt.CHECKMARK, {
            title: 'Event', width: -60, on_click: row => {
                if(row.item.event_id)
                    $location.push('event', { event_id: row.item.event_id })
            }
        });

        def.addButtons([
            {
                icon: UIIcon.CIRCLE_PLUS, tooltip: 'Add subtitles', action: (_v, _row) => {
                    // new AddSubtitleDialog(v).present().then(() => {
                    //     row.reload();
                    // });
                }
            },
            {
                icon: UIIcon.PENCIL, tooltip: 'Edit', action: v => {
                    $location.push({ transient: new VideoScreen(v) });
                }
            },
            {
                icon: UIIcon.CIRCLE_PLAY, tooltip: 'Play', when: v => v.status == 'complete', action: v => {
                    new UIVideoDialog(v.master_url).present();
                }
            }
        ], { width: -93 });

        def.preference_prefix = 'vods';

        const source = new YArrayDataSource<VVideo>

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block', [
                filter_bar,
                new UITable(def, source),
            ])),
            makeActionButton(UIIcon.PLUS, 'New provider', () => { new UploadVideoDialog().present().then(doSearch) })
        ]);

        doSearch();
    }
}
